const reducer = (state, action) => {
  switch (action.type) {
    case "storeCollections":
      return {
        ...state,
        topCollection: action.payload,
        topCollectionCopy: action.payload,
      };

      case 'filterCollection' : 
      const filteredItem = state.topCollection.filter((element , index) => {
        return element.category === 'a';
      })
      console.log(filteredItem);

      return {
        ...state , 
        topCollection : filteredItem,
      }

    default:
      return state;
  }
};

export default reducer;
